import { ApplicationInsights } from "@microsoft/applicationinsights-web";

let appInsights: ApplicationInsights | undefined;

function getConnectionString(): string | undefined {
  const value = import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING;
  return value && value.trim() ? value.trim() : undefined;
}

export function initializeTelemetry(): void {
  const connectionString = getConnectionString();
  if (!connectionString || appInsights) {
    return;
  }

  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      disableAjaxTracking: false,
      disableFetchTracking: false
    }
  });

  appInsights.loadAppInsights();
}

export function trackPageView(name: string, uri = window.location.href): void {
  appInsights?.trackPageView({ name, uri });
}

export function trackEvent(name: string, properties?: Record<string, string | number | boolean | undefined>): void {
  appInsights?.trackEvent({ name }, properties);
}

export function setTelemetryUser(userId?: string, accountId?: string): void {
  if (!appInsights || !userId) {
    return;
  }

  appInsights.setAuthenticatedUserContext(userId, accountId, true);
}

export function clearTelemetryUser(): void {
  appInsights?.clearAuthenticatedUserContext();
}
